(function(){
  function init(root){
    var slides=root.querySelectorAll('.lb-slide');
    var dots=root.querySelectorAll('.lb-dot');
    var n=slides.length, i=0, timer=null;
    var autoplay=root.getAttribute('data-autoplay')==='true';
    var speed=(parseInt(root.getAttribute('data-speed'),10)||5)*1000;
    function go(k){ i=(k+n)%n; for(var a=0;a<slides.length;a++){ slides[a].classList.toggle('is-active',a===i); } for(var d=0;d<dots.length;d++){ dots[d].classList.toggle('is-active',d===i); } }
    function next(){ go(i+1); }
    function prev(){ go(i-1); }
    function stop(){ if(timer){ clearInterval(timer); timer=null; } }
    function start(){ if(autoplay&&n>1){ stop(); timer=setInterval(next,speed); } }
    var na=root.querySelector('.lb-next'), pa=root.querySelector('.lb-prev');
    if(na){ na.addEventListener('click',function(){ next(); start(); }); }
    if(pa){ pa.addEventListener('click',function(){ prev(); start(); }); }
    for(var d2=0;d2<dots.length;d2++){ (function(idx){ dots[idx].addEventListener('click',function(){ go(idx); start(); }); })(d2); }
    var mute=root.querySelector('.lb-mute');
    if(mute){ mute.addEventListener('click',function(){ var m=mute.getAttribute('data-muted')!=='true'; var v=root.querySelectorAll('video'); for(var x=0;x<v.length;x++){ v[x].muted=m; } mute.setAttribute('data-muted',m?'true':'false'); mute.classList.toggle('is-muted',m); }); }
    root.addEventListener('mouseenter',stop);
    root.addEventListener('mouseleave',start);
    go(0); start();
  }
  function boot(){ var r=document.querySelectorAll('.lb'); for(var i=0;i<r.length;i++){ init(r[i]); } }
  if(document.readyState!=='loading'){ boot(); } else { document.addEventListener('DOMContentLoaded',boot); }
})();
